import { Trans, useTranslation } from "react-i18next";

interface DepositAlternativeProps {
  hideHeader?: boolean;
}

const DepositAlternative = ({ hideHeader }: DepositAlternativeProps) => {
  const { t } = useTranslation("enrollment");
  return (
    <div>
      {!hideHeader ? (
        <p>
          <Trans i18nKey="enrollment:depositWaiverLine1">
            We may be able to waive your deposit if you qualify under any of the
            following, please call us at{" "}
            <a href="tel:8887335557">(888) 733-5557</a> to learn more about
            these options.
          </Trans>
        </p>
      ) : (
        <p>{t("depositWaiverDocTitleDefer")}</p>
      )}
      <p>
        <Trans
          i18nKey="enrollment:depositWaiverLine2"
          components={{ 2: <b /> }}
        >
          <b>Letter of credit from a previous electric provider</b> – A
          residential customer or applicant may be deemed as having established
          satisfactory credit if the customer or applicant:
        </Trans>
      </p>
      <ul style={{ marginLeft: "20px", listStyleType: "disc" }}>
        <li>
          {t(
            "Has been a customer of any retail electric provider or an electric utility within the two years prior to the request for electric service;"
          )}
        </li>
        <li>
          {t(
            "Is not delinquent in payment of any such electric service account; and"
          )}
        </li>
        <li>
          {t(
            "During the last 12 consecutive months of service was not late in paying a bill more than once."
          )}
        </li>
      </ul>
      <br />
      <p>
        <Trans
          i18nKey="enrollment:depositWaiverLine3"
          components={{ 3: <b /> }}
        >
          <b>65 or Older</b> – A residential customer or applicant may be deemed
          as having established satisfactory credit if the customer or applicant
          is 65 years of age or older and the customer is not currently
          delinquent in payment of any electric service account.
        </Trans>
      </p>
      <p>
        <Trans
          i18nKey="enrollment:depositWaiverLine4"
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          components={{ 4: <b />, 6: <a href="tel:1-800-681-1950" /> }}
        >
          <b>Victim of Family Violence</b> – A residential customer or applicant
          may be deemed as having established satisfactory credit if the
          customer or applicant has been determined to be a victim of family
          violence as defined in the Texas Family Code §71.004, by a family
          violence center as defined in Texas Human Resources Code §51.002, by
          treating medical personnel, by law enforcement personnel, by the
          Office of a Texas District Attorney or County Attorney, by the Office
          of the Attorney General, or by a grantee of the Texas Equal Access to
          Justice Foundation. This determination shall be evidenced by
          submission of a certification letter from the Texas Council of Family
          Violence. The certification letter may be submitted directly to
          CleanSky Energy by faxing a copy to{" "}
          <a href="tel:1-800-681-1950">1-800-681-1950</a> toll-free.
        </Trans>
      </p>
    </div>
  );
};

export default DepositAlternative;
